import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

class HamburgerMenu extends React.Component<{style?: {[key: string]: any}}> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { style } = this.props;

    return (
      <svg height={35} width={35} viewBox='0 0 24 24' style={{ ...style }}>
        <path fill={colors.primary} d='M24,6H0V2h24V6z M24,10H0v4h24V10z M24,18H0v4h24V18z'/>
      </svg>

    );
  }
}

export default HamburgerMenu;



// WEBPACK FOOTER //
// ./src/modules/svgs/hamburger_menu/index.web.tsx